export interface OrderState {
	loading: boolean;
	orderId: number;
	error: any;
	isCompleted: boolean;
}

export const initialState: OrderState = {
	loading: false,
	orderId: 0,
	error: null,
	isCompleted: false,
};

export interface QuoteOrderPayload {
	firstname: string;
	lastname: string;
	pwaccountid: string | number;
	orderinstruction: string;
	email: string;
	phoneno: string;
	purpose: string;
	orderduedate: string;
	jobname: string;
	pono: string;
	company: string;
	receiverpwaccountid: number;
	ordertype?: number;
	receiveraccountaddressid: number;
	sourceapptype?: number;
	timezoneoffset?: number;
	printsize?: string;
	papertype?: string;
	bindtype?: string;
	noofsets?: string;
	arcaccountno?: string;
	willcall?: boolean;
	address1?: string;
	city?: string;
	CountryName?: string;
	ZipCode?: string;
	StateName?: string;
	stateid?: string;
	countryid?: string;
}

export enum OrderType {
	PRINT_ORDER = 1,
	SEND_FILES = 2,
	MULTI_ORDER = 3,
	THIRD_PARTY = 4,
	SEND_FILES_FROM_OUTLOOK = 5,
	SEND_FILES_FROM_PRINTER = 6,
	PICKUP_REQUEST = 7,
	QUOTE_REQUEST = 8,
	HEALTH_AND_WELLNESS = 9,
	RIOT_ORDERS = 10,
}

export interface IOrderItem {
	orderId: string | number;
	fileName: string;
	fileSize: number;
	uploadType: number;
	filePath: string;
	fileSno: number;
	fileStatus: number;
	orderActivityId: number;
	createBy: number;
	refOrderItemType: number;
	// s3Path: string;
	folderName: string;
}
export interface UpdateOrderPayload {
	orderItems: IOrderItem[];
}

export interface MarkOrderCompletePayload {
	totalCount: number;
	orderId: string | number;
	fileSize: number;
	zipName: string;
}
